export class NetConfig {
  name!: string;
  enabled?: boolean;
  macAddress?: string;
  netmask?: string;
  ip?: string;
  dns?: string;
  dhcp?: boolean;
  gateway?: string;

  constructor(name: string, data: any) {
    this.name = name;
    this.enabled = data.enabled;

    if (this.enabled) {
      this.macAddress = data.macAddress;
      this.netmask = data.netmask;
      this.ip = data.ip;
      this.dns = data.dns;
      this.dhcp = data.dhcp;
      this.gateway = data.gateway;
    } else {
      this.dhcp = false;
    }
  }
}
